<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="padding:20px;width:100%;box-sizing: border-box;">
      <el-button size="small" @click="back" icon="el-icon-arrow-left" class="back">返回</el-button>
      <el-row class="mt2" type="flex" justify="center" style="background:#fff;padding:35px 0 20px 0;">
        <el-col :span="8" style="position: relative;">
          <el-steps :active="active" process-status="success" :align-center="true">
            <el-step title="待提交"></el-step>
            <el-step title="已提交"></el-step>
            <el-step title="订单已审核"></el-step>
            <el-step title="已配车"></el-step>
          </el-steps>
          <img v-if="form.extOrderId" style="position: absolute; top: -35px; right: -60px;" :src="customerOrder.isLocked ? locked : unlocked" width="80px" height="80px" alt="">
        </el-col>
      </el-row>
      <el-row class="mt1" type="flex" justify="space-between">
        <el-col :span="17">
          <el-form ref="form" :inline="true" label-position="right" :model="form" :rules="formRules" label-width="120px">
            <el-row type="flex" justify="space-between" align="middle">
              <div class="title" style="width:200px">
                车辆信息
                <span @click="toCustomer" style="color:#409EFF" v-if="formName != 'customerDetail'"
                  class="toCustomer">客户详情</span>
              </div>
              <el-form-item class="form_item" label-width="260px" v-if="form.extOrderId != ''"
                :label="'销售订单号:' + form.extOrderId">
                <div style="color:#409EFF;cursor: pointer;" v-if="allowTransferAudit" @click="
                  transferAudit = true;
                getTransferAudits();
                ">
                  线上订单异常申请？
                </div>
              </el-form-item>
              <div style="display:flex;height:30px">
                <el-button size="mini" @click="disabled = false" v-if="disabled"
                  style="margin-right:10px !important;">修改</el-button>
                <el-button size="mini" @click="Cancel" v-if="!disabled && !confirmLoading"
                  style="margin-right:10px !important;">取消</el-button>
                <el-button size="mini" @click="Save" style="margin-right:10px !important;" :loading="confirmLoading"
                  v-if="!disabled">保存</el-button>
                <el-button v-if="allowCancel && disabled" size="mini" @click="backOrder" style="margin-right:10px !important;">退订</el-button>
                <el-button size="mini" v-if="allowAssignVehicle && disabled" @click="submit">保存并同步销服</el-button>
              </div>
            </el-row>
            <el-row style="background:#fff;padding:15px 0;">
              <el-form-item class="form_item" label="合同编号" v-if="disabled" prop="contractNo">
                <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="form.contractNo"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="订单类型" prop="orderType">
                <el-select size="mini" style="width:160px;" placeholder="请选择" v-model="form.orderType">
                  <el-option v-for="item in orderTypeDics" :key="item.dataValue" :label="item.dataDisplay"
                    :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="订购车型" prop="modelId">
                <el-cascader size="mini" class="filter-item" :disabled="disabled" style="width: 330px;"
                  placeholder="选择订购车型" filterable :show-all-levels="true" :options="carOptions" v-model="form.modelId"
                  @change="changeSpecColor"></el-cascader>
              </el-form-item>
              <el-form-item class="form_item" label="车辆状态" v-if="form.otdStatus != ''">
                <div style="width:160px;">{{ form.otdStatus }}</div>
              </el-form-item>
              <el-form-item class="form_item" label="外观颜色" prop="modelColor">
                <el-select size="mini" style="width:160px;" placeholder="请选择" :disabled="disabled"
                  v-model="form.modelColor" @change="modelColorChange">
                  <el-option v-for="item in colors" :key="item.color" :label="item.color + '(' + item.total + ')'"
                    :value="item.color"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="内饰">
                <el-select size="mini" :disabled="disabled" style="width:160px;" placeholder="请选择"
                  v-model="form.carInternalColor" @change="carInternalColorChange">
                  <el-option v-for="(item, index) in carInternalColor" :key="index" :label="item === '' ? '无' : item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-for="(options, key) in carModelOptionalsComputed" :key="key" class="form_item" :label="modelOptionalsKeyMap.get(key)">
                <el-select
                  size="mini"
                  :disabled="disabled"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.carModelOptionals[key]"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :value="item === '无选装' ? '' : item"
                    :label="item === '' ? '无' : item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="车架号" prop="modelVin" v-if="disabled">
                <el-select size="mini" style="width:160px;" placeholder="请选择" v-model="form.modelVin">
                  <el-option v-for="item in vins" :key="item.vin" :label="item.vin" :value="item.vin"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="是否三包车" prop="isSanbao" v-if="disabled">
                <el-select size="mini" style="width:160px;" placeholder="请选择" v-model="form.isSanbao">
                  <el-option :value="true" label="是"></el-option>
                  <el-option :value="false" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="订金" prop="paymentDown">
                <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="form.paymentDown"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="订车原因">
                <el-select size="mini" style="width:200px;" placeholder="请选择" v-model="form.orderReason" multiple>
                  <el-option v-for="(item, index) in failProductReasonDics" :key="index" :label="item.dataName"
                    :value="item.dataName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="对比车型">
                <el-select size="mini" style="width:250px;" placeholder="请选择" v-model="form.competeSeriesId">
                  <el-option v-for="(item, index) in competitionSeries" :key="index"
                    :label="item.brandName + ' ' + item.seriesName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="购车类型" prop="businessType">
                <el-select size="mini" style="width:160px;" placeholder="请选择" v-model="form.businessType">
                  <el-option v-for="item in businessTypeOptions" :key="item.dataValue" :label="item.dataDisplay"
                    :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="收款方式" prop="payType">
                <el-select size="mini" style="width:160px;" placeholder="请选择" v-model="form.payType">
                  <el-option label="全款" :value="1"></el-option>
                  <el-option label="按揭" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="成交金额" prop="paymentDeal" v-if="disabled">
                <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="form.paymentDeal"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="其他费用" v-if="disabled">
                <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="form.paymentOther"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="车辆用途" prop="vehiclePurpose" v-if="disabled">
                <el-select size="mini" style="width:160px;" placeholder="请选择" v-model="form.vehiclePurpose">
                  <el-option v-for="item in orderVehiclePurposeDics" :key="item.dataValue" :label="item.dataDisplay"
                    :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="是否置换" v-if="disabled">
                <el-select size="mini" style="width:160px;" placeholder="请选择" v-model="form.isReplace">
                  <el-option :value="true" label="是"></el-option>
                  <el-option :value="false" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="置换车牌号" v-if="form.isReplace && disabled" prop="replacedCarNum">
                <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="form.replacedCarNum"></el-input>
              </el-form-item>
              <el-form-item class="form_item" v-if="form.isReplace && disabled" label="置换旧车品牌">
                <el-select size="mini" style="width:160px;" placeholder="请选择" v-model="form.replacedBrand">
                  <el-option :value="1" label="比亚迪"></el-option>
                  <el-option :value="2" label="非比亚迪"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="置换旧车车系" v-if="form.isReplace && form.replacedBrand === 2 && disabled"
                prop="replacedSeries">
                <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="form.replacedSeries"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="置换旧车车系" v-if="form.isReplace && form.replacedBrand === 1 && disabled"
                prop="replacedSeries">
                <el-select size="mini" style="width:160px;" v-model="form.replacedSeries">
                  <el-option v-for="item in seriesOptions" :key="item.id" :label="item.name"
                    :value="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="是否二级店销售" v-if="disabled">
                <el-select size="mini" style="width:160px;" placeholder="请选择" v-model="form.isSaledBySecond">
                  <el-option :value="true" label="是"></el-option>
                  <el-option :value="false" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="预计交车时间">
                <el-date-picker size="mini" style="width:160px;" v-model="form.deliverDate" :clearable="false" type="date"
                  value-format="timestamp" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </el-row>
            <el-row style="margin-top:10px">
              <div class="title">客户信息</div>
            </el-row>
            <el-row style="background:#fff;padding:15px 0;">
              <el-form-item class="form_item" label="类型" prop="customerType">
                <el-select size="mini" style="width:160px;" placeholder="请选择" v-model="form.customerType" disabled>
                  <el-option label="个人" :value="1"></el-option>
                  <el-option label="企业" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" :label="form.customerType === 1 ? '订车人姓名' : '公司名称'" prop="customerName">
                <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model.trim="form.customerName"
                  disabled></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="联系电话" prop="customerPhone">
                <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="form.customerPhone"
                  :disabled="disabled"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="证件类型" prop="identifyType">
                <el-select size="mini" style="width:160px;" placeholder="请选择" v-model="form.identifyType" disabled>
                  <el-option v-for="item in orderIdentifyTypeDics" :key="item.dataValue" :label="item.dataDisplay"
                    :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="证件号码" prop="identifyNo">
                <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="form.identifyNo"
                  disabled></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="推荐人姓名" prop="referrerName">
                <el-input size="mini" disabled style="width: 160px;" placeholder="请输入"
                  v-model="form.referrerName"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="推荐人电话" prop="referrerPhone">
                <el-input size="mini" disabled style="width: 160px;" placeholder="请输入"
                  v-model="form.referrerPhone"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="省/市/区">
                <el-select size="mini" style="width:100px;" placeholder="选择省" clearable @change="provinceChange"
                  v-model="form.customerProvince">
                  <el-option v-for="item in provinces" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select size="mini" style="width:100px;" placeholder="选择市" clearable @change="cityChange"
                  v-model="form.customerCity">
                  <el-option v-for="item in citys" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select size="mini" style="width:100px;" placeholder="选择区" clearable v-model="form.customerCounty">
                  <el-option v-for="item in countys" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="详细地址" prop="customerAddress">
                <el-input size="mini" style="width: 300px;" placeholder="请输入" v-model="form.customerAddress"></el-input>
              </el-form-item>
            </el-row>
            <el-row style="margin-top:10px">
              <div class="title">其他信息</div>
              <el-row style="background:#fff;padding:15px 0;">
                <el-form-item class="form_item" label="成交渠道">
                  <el-input v-if="form.reactivateSource" size="mini" style="width: 160px;" v-model="form.reactivateSource" disabled></el-input>
                  <el-input v-else size="mini" style="width: 160px;" v-model="form.sourceName" disabled></el-input>
                </el-form-item>
                <el-form-item class="form_item" label="备注">
                  <el-input type="textarea" style="width:330px;" :rows="2" placeholder="请输入备注内容"
                    v-model="form.remark"></el-input>
                </el-form-item>
              </el-row>
              <el-row style="background:#fff;padding:15px 0;">
                <el-col :span="12">
                  <el-form-item class="form_item" label="订车合同/协议(最多三张)">
                    <Upload ref="upload1" v-model="form.images1" :disabled="hideUpload1||disabled"></Upload>
                    <!-- <el-upload action accept=".jpeg,.jpg,.png" :limit="3" ref="upload1" :file-list="fileList1"
                      :http-request="uploadRequest" :on-remove="handleRemove1" :class="{ hide: hideUpload1||disabled }"
                      :on-success="handleUploadSuccess1" :on-change="handleUploadChange1" :before-upload="uploadBefore"
                      list-type="picture-card">
                      <i slot="default" class="el-icon-plus"></i>
                      <div slot="file" slot-scope="{ file }">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                        <span class="el-upload-list__item-actions">
                          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview1(file)">
                            <i class="el-icon-zoom-in"></i>
                          </span>
                        </span>
                      </div>
                      <div slot="tip" class="el-upload__tip" v-if="fileList1.length > 0">
                        注：配车阶段不允许修改或删除合同图片
                        <br />支持JPG、JPEG、PNG格式
                      </div>
                    </el-upload> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="form_item" label="交易凭证">
                    <Upload ref="upload2" v-model="form.images2" :disabled="hideUpload2||disabled"></Upload>
                    <!-- <el-upload action accept=".jpeg,.jpg,.png" :limit="3" ref="upload2" :disabled="!allowAssignVehicle"
                      :http-request="uploadRequest" :file-list="fileList2" :class="{ hide: hideUpload2||disabled }"
                      :on-success="handleUploadSuccess2" :on-change="handleUploadChange2" :before-upload="uploadBefore"
                      list-type="picture-card">
                      <i slot="default" class="el-icon-plus"></i>
                      <div slot="file" slot-scope="{ file }">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                        <span class="el-upload-list__item-actions">
                          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview2(file)">
                            <i class="el-icon-zoom-in"></i>
                          </span>
                          <span class="el-upload-list__item-delete" @click="handleRemove2(file)">
                            <i class="el-icon-delete"></i>
                          </span>
                        </span>
                      </div>
                      <div slot="tip" class="el-upload__tip" v-if="fileList2.length > 0">
                        支持JPG、JPEG、PNG格式
                      </div>
                    </el-upload> -->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="7" style="margin-left:20px">
          <div class="title">订单操作记录</div>
          <el-row style="min-height:196px;background:#fff">
            <el-timeline style="margin-top:15px;margin-left:30px">
              <el-timeline-item v-for="(item, index) in timelines" :key="index" color="#0bbd87"
                :timestamp="parseTime(item.createdAt, '{y}/{m}/{d} {h}:{i}')">
                <div class="boxLine">
                  <div class="title">{{ item.orderStatus | orderStatus }}</div>
                  <span v-html="item.content.replaceAll('\n', '<br/>')"></span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="驳回订单" :visible.sync="orderCancelLog" width="500px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="orderCancelForm" :rules="orderCancelRules" label-position="right" :model="orderCancelForm"
        label-width="80px">
        <el-row>
          <!-- <el-form-item class="form_item_val" :label="item.label" v-for="(item, index) in orderBackReasonTags"
            :key="index">
            <el-tag v-for="radio in item.radios" :key="radio" :type="
            orderCancelForm['content' + (index + 1)] === radio ? 'danger' : 'info'" @click="tagSelect2(radio, index)">
              {{
                  radio
              }}</el-tag>
          </el-form-item>-->
          <el-form-item class="form_item_val" label="驳回原因" prop="remark">
            <el-input type="textarea" :rows="4" placeholder="请输入订单驳回的原因" v-model="orderCancelForm.remark"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderCancelLog = false" type="text">取消</el-button>
        <el-button @click="orderCanceConfim" type="text" :loading="confirmLoading">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="是否确定配车并同步销服" :visible.sync="orderThroughLog" width="370px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="orderThroughForm" label-position="right" label-width="100px">
        <el-row>
          <el-form-item class="form_item_val" label="订购车型">{{
            modelDisplay.split("/")[0] + "/" + modelDisplay.split("/")[1]
          }}</el-form-item>
          <el-form-item class="form_item_val" label="外观颜色">{{
            modelDisplay.split("/")[2]
          }}</el-form-item>
          <el-form-item class="form_item_val" label="车架号">{{
            form.modelVin
          }}</el-form-item>
        </el-row>
      </el-form>
      <div class="ps">注：同步销服后，信息将不能更改，请知晓</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderThroughLog = false" type="text">取消</el-button>
        <el-button @click="orderThroughConfim" type="text" :loading="confirmLoading">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="订单退订" :visible.sync="backOrderLog" width="500px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="backOrderForm" :rules="backOrderRules" label-position="right" :model="backOrderForm"
        label-width="80px">
        <el-row>
          <el-form-item class="form_item_val" :label="item.label" v-for="(item, index) in orderReturnReasonTags"
            :key="index">
            <template v-if="item.label === '已购竞品'">
              <el-select
                size="mini"
                style="width:180px;"
                placeholder="请选择"
                v-model="backOrderForm['competitive']"
                @change="competitiveChange"
                clearable
                filterable
              >
                <el-option v-for="(item, index) in competitionSeries" :key="index" :label="`${item.brandName} ${item.seriesName}`" :value="`${item.brandName} ${item.seriesName}`"></el-option>
              </el-select>
            </template>
            <template v-else>
              <el-tag v-for="radio in item.radios" :key="radio"
                :type="backOrderForm.content === radio ? 'danger' : 'info'" @click="tagSelect(radio, index)">
                {{ radio }}
              </el-tag>
            </template>
          </el-form-item>
          <el-form-item class="form_item_val" label="退订原因" :prop="backOrderForm.content === '' && backOrderForm.competitive === '' ? 'remark' : ''">
            <el-input type="textarea" :rows="4" placeholder="请输入退订原因" v-model="backOrderForm.remark"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backOrderLog = false" type="text">取消</el-button>
        <el-button @click="backOrderConfim" type="text" :loading="confirmLoading">确定</el-button>
      </span>
    </el-dialog>
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="fileList"  :initialIndex="initialIndex" />
    <el-dialog title="线上订单异常申请" :visible.sync="transferAudit" width="1200px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-row>
        <el-col :span="13">
          <el-form ref="transferForm" :rules="transferRules" label-position="right" :model="transferForm"
            label-width="90px">
            <el-form-item class="form_item_val" label="问题分类" prop="reason">
              <el-radio-group v-model="transferForm.reason">
                <el-radio label="在销服上下订"></el-radio>
                <br />
                <el-radio label="在销服上修改订单"></el-radio>
                <br />
                <el-radio label="退订后重新下订"></el-radio>
                <br />
                <el-radio label="修改车系"></el-radio>
                <br />
                <el-radio label="其他，请描述"></el-radio>
              </el-radio-group>
              <el-input type="textarea" v-if="transferForm.reason === '其他，请描述'" :rows="4" placeholder="请输入"
                v-model="transferForm.reason2"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item class="form_item" label="APP订单附件" prop="images3">
                  <el-upload action accept=".jpeg,.jpg,.png" :limit="1" :class="{ hide: transferForm.image1 != '' }"
                    :http-request="uploadRequest" :on-success="handleUploadSuccess3" :before-upload="uploadBefore"
                    list-type="picture-card">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                      <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="form_item" label="销服订单附件" prop="images3">
                  <el-upload action accept=".jpeg,.jpg,.png" :limit="1" :class="{ hide: transferForm.image2 != '' }"
                    :http-request="uploadRequest" :on-success="handleUploadSuccess4" :before-upload="uploadBefore"
                    list-type="picture-card">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                      <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item class="form_item" label="智蛛订单附件" prop="images3">
                  <el-upload action accept=".jpeg,.jpg,.png" :limit="1" :class="{ hide: transferForm.image3 != '' }"
                    :http-request="uploadRequest" :on-success="handleUploadSuccess5" :before-upload="uploadBefore"
                    list-type="picture-card">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                      <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="form_item" label="其他订单附件" prop="images3">
                  <el-upload action accept=".jpeg,.jpg,.png" :limit="1" :class="{ hide: transferForm.image4 != '' }"
                    :http-request="uploadRequest" :on-success="handleUploadSuccess6" :before-upload="uploadBefore"
                    list-type="picture-card">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                      <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="11">
          <div style="margin-bottom:10px">历史记录</div>
          <div class="boxTransfer">
            <div v-for="(item, index) in transfers" :key="index">
              <div>
                <div>
                  <span>申请时间:</span>
                  {{ parseTime(item.applyTime) }}
                </div>
                <div>
                  <span>订单状态:</span>
                  {{ Number(item.orderStatus) | orderStatus }}
                </div>
                <div>
                  <span>问题分类:</span>
                  {{ item.reason }}
                </div>
                <div>
                  <span>审核结果:</span>
                  {{ item.auditRemark }}
                </div>
              </div>
              <div style="margin-right:20px;font-size:15px;font-weight: bold;">
                {{ item.auditStatus | auditStatus }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="transferAudit = false" type="text">取消</el-button>
        <el-button @click="transferConfim" type="text" :loading="confirmLoading">确定</el-button>
      </span>
    </el-dialog>
    <!-- 提交审批 -->
    <el-dialog :visible.sync="SubmitLog" width="500px" title="是否提交管理层进行审批">
      <el-form label-position="left" label-width="80px">
        <el-form-item class="form_item" label="核销码" prop="reason">
          <el-input placeholder="请输入" size="mini" style="width:200px" v-model="code"></el-input>
          <el-button @click="sendSms" v-show="isSend" type="primary" size="mini">发送</el-button>
          <el-button v-show="!isSend" type="primary" size="mini" disabled>{{ time }}s后重新发送</el-button>
        </el-form-item>
        <p class="pss">
          点击发送将发送核销码给到订单手机号码或客户“比亚迪汽车”小程序系统通知中
        </p>
        <!-- <div class="pss">{{ remark }}</div> -->
      </el-form>
      <div class="submit-fo" style="padding-bottom:10px">
        <el-button @click="SubmitLog = false" size="mini">取消</el-button>
        <el-button type="primary" style="margin-left:25px!important;" @click="checkCode" :loading="subLoading"
          size="mini">确定</el-button>
      </div>
    </el-dialog>
    <!-- blc拦截弹窗 -->
    <blc-tips :visible.sync="showBlcTips" :info="blcInfo"></blc-tips>
  </div>
</template>

<script>
import BlcTips from "@/components/blc-tips/index.vue";
import ElImageViewer from "./image-viewer";
import oss from '../../assets/js/ali-oss';
import { remarkValidator, isEmptyVal, getUrls } from '@/assets/js/util'
import { modelOptionalsKeyMap, orderStatusDics } from './constants.js'
import Upload from "@/components/common/Upload.vue";
import locked from '../../assets/img/locked.svg'
import unlocked from '../../assets/img/unlocked.svg'
var order_vm;
export default {
  components: { ElImageViewer, BlcTips, Upload },
  data() {
    const validateReplacedCarNum = (rule, value, callback) => {
      if (this.form.isReplace) {
        var xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
        var creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
        if (value.length == 7) {
          if (creg.test(value)) {
            callback();
          } else {
            callback(new Error("请输入正确车牌号"));
          }
        } else if (value.length == 8) {
          if (xreg.test(value)) {
            callback();
          } else {
            callback(new Error("请输入正确车牌号"));
          }
        } else {
          callback(new Error("请输入正确车牌号"));
        }
      }
    };
    const validatePhTelNumber = (rule, value, callback) => {
      const telNumber = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (!telNumber.test(value)) {
        callback(new Error("请输入正确的联系电话"));
      } else {
        callback();
      }
    };
    order_vm = this;
    return {
      locked,
      unlocked,
      modelOptionalsKeyMap,
      showBlcTips: false,
      blcInfo: {},
      initialIndex: 0,
      SubmitLog: false,
      isSend: true,
      time: 60,
      code: "",
      subLoading: false,
      // remark: "",
      transferAudit: false,
      allowTransferAudit: false,
      needCheckOrder: false,
      transferForm: {
        reason: "",
        reason2: "",
        image1: "",
        image2: "",
        image3: "",
        image4: "",
      },
      transfers: [],
      transferRules: {
        reason: [
          {
            required: true,
            message: "请选择问题分类",
            trigger: "blur",
          },
        ],
      },
      dealer: this.$common.getLoginInfo().profile,
      //   allowOrderVerify: this.$common.getLoginInfo().allowOrderVerify,
      type: this.$route.query.type,
      orderId: Number(this.$route.query.id),
      isAdmin: this.$common.getAdmin(),
      formName: sessionStorage.getItem("form"),
      active: 2,
      dialogVisible: false,
      dialogImageUrl: "",
      hideUpload1: false,
      fileList: [],
      fileList1: [],
      hideUpload2: false,
      hideUpload3: false,
      fileList2: [],
      fileList3: [],
      seriesOptions: [],
      form: {
        otdStatus: "",
        contractNo: "",
        orderType: "",
        modelId: [],
        modelColor: "",
        modelVin: "",
        isSanbao: true,
        paymentDown: "",
        payType: 2,
        // paymentFirst: '',
        // paymentYears: '',
        paymentDeal: "",
        paymentOther: "",
        vehiclePurpose: "",
        isReplace: false,
        replacedCarNum: "",
        isSaledBySecond: false,
        // secondDealerName: "",
        customerType: 1,
        customerName: "",
        customerPhone: "",
        identifyType: 1,
        identifyNo: "",
        identifyNos: "",
        customerAddress: "",
        address: [],
        deliverDate: "",
        // isReport: true,
        // nextFollowDate: '',
        remark: "",
        mortgagePayment: "",
        customerProvince: "",
        customerCity: "",
        customerCounty: "",
        replacedBrand: 1,
        replacedSeries: "",
        extOrderId: "",
        orderReason: [],
        competeSeriesId: '',
        carInternalColor: '',
        carModelOptionals: {
          optional1: "",
          optional2: "",
          optional3: "",
          optional4: "",
          optional5: "",
          optional6: "",
          optional7: "",
          optional8: "",
          optional9: "",
        }, // 车型选装
        businessType: '', // 购车类型
      },
      formRules: {
        contractNo: [
          {
            required: true,
            message: "请输入合同编号",
            trigger: "blur",
          },
        ],
        replacedCarNum: [
          {
            required: true,
            validator: validateReplacedCarNum,
            trigger: "blur",
          },
        ],
        images1: [
          {
            required: true,
            message: "请上传合同/协议",
            trigger: "blur",
          },
        ],
        orderType: [
          {
            required: true,
            message: "请选择订单类型",
            trigger: "blur",
          },
        ],
        secondDealerName: [
          {
            required: true,
            message: "请选择二级店名",
            trigger: "blur",
          },
        ],
        modelId: [
          {
            required: true,
            message: "请选择订购车型",
            trigger: "blur",
          },
        ],
        modelColor: [
          {
            required: true,
            message: "请选择外观颜色",
            trigger: "blur",
          },
        ],
        modelVin: [
          {
            required: true,
            message: "请选择车架号",
            trigger: "blur",
          },
        ],
        isSanbao: [
          {
            required: true,
            message: "请选择是否三包车",
            trigger: "blur",
          },
        ],
        paymentDown: [
          {
            required: true,
            message: "请输入订金",
            trigger: "blur",
          },
        ],
        payType: [
          {
            required: true,
            message: "请选择付款方式",
            trigger: "blur",
          },
        ],
        paymentDeal: [
          {
            required: true,
            message: "请输入成交金额",
            trigger: "blur",
          },
        ],
        vehiclePurpose: [
          {
            required: true,
            message: "请选择车辆用途",
            trigger: "blur",
          },
        ],
        customerType: [
          {
            required: true,
            message: "请选择客户类型",
            trigger: "blur",
          },
        ],
        customerName: [
          {
            required: true,
            message: "请输入订车人姓名",
            trigger: "blur",
          },
        ],
        identifyType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "blur",
          },
        ],
        identifyNo: [
          {
            required: true,
            message: "请输入证件号码",
            trigger: "blur",
          },
        ],
        customerPhone: [
          {
            required: true,
            validator: validatePhTelNumber,
            trigger: "blur",
          },
        ],
        replacedSeries: [
          {
            required: true,
            message: "请输入旧车车系",
            trigger: "blur",
          },
        ],
        deliverDate: [
          {
            required: true,
            message: "请选择预计交车时间",
            trigger: "blur",
          },
        ],
        nextFollowDate: [
          {
            required: true,
            message: "请选择下次跟进时间",
            trigger: "blur",
          },
        ],
        businessType: [
          {
            required: true,
            message: "请选择购车类型",
            trigger: "blur",
          },
        ],
      },
      orderTypeDics: [], // 订单类型
      orderLoadDurationDics: [], // 按揭期数
      orderVehiclePurposeDics: [], // 车辆用途
      orderIdentifyTypeDics: [], // 证件类型
      businessTypeOptions: [], // 购车类型
      orderStatusDics, // 订单状态
      carOptions: [], // 订购车型
      colors: [], //车辆颜色
      vins: [], // 车架号
      orderCancelLog: false,
      timelines: [],
      disabled: true,
      orderCancelForm: {
        remark: "",
        // content1: '',
        // content2: '',
        // content3: '',
        // content4: '',
        // content5: '',
      },
      orderCancelRules: {
        remark: [
          {
            required: true,
            validator: (...args) => {
              remarkValidator("订单驳回的原因", ...args)
            },
            trigger: "blur",
          },
        ],
      },
      confirmLoading: false,
      orderThroughLog: false,
      orderThroughForm: {
        isSyncSiebel: true,
        remark: "",
      },
      secondDealers: [],
      modelDisplay: "",
      allowAssignVehicle: false,
      allowCancel: false,
      show: false,
      data: {},
      backOrderLog: false,
      backOrderRules: {
        remark: [
          {
            required: true,
            validator: (...args) => {
              remarkValidator("订单退订的原因", ...args)
            },
            trigger: "blur",
          },
        ],
      },
      competitionSeriesList: [], // 竞品品牌车系
      backOrderForm: {
        remark: "",
        content: "",
        tagIndex: "",
        competitive: "", // 已购竞品
      },
      provinces: [],
      citys: [],
      countys: [],
      showViewer: false,
      uploadData: {
        key: "",
        token: "",
        url: "",
      },
      orderReturnReasonTags: [],
      // orderBackReasonTags: [],
      oldForm: {},
      carInternalColor: [],
      carModelOptionalsMaps: {},
      failProductReasonDics: [],
      competitionSeries: [],
      customerOrder: {}
    };
  },
  computed: {
    isEditing() {
      return this.disabled === false
    },
    carModelOptionalsComputed() {
      let value = {}
      for (const key in this.carModelOptionalsMaps) {
        if(Object.prototype.hasOwnProperty.call(this.carModelOptionalsMaps, key) && this.carModelOptionalsMaps[key] && this.carModelOptionalsMaps[key].some(Boolean)) {
          value[key] = this.carModelOptionalsMaps[key]
          if(this.isEditing && !this.form.carModelOptionals[key]) {
            this.form.carModelOptionals[key] = (value[key][0] === '无选装' ? '' : value[key][0])
          }
        }
      }
      return value
    }
  },
  created() {
    var baseInfo = this.$common.getBaseInfo();
    this.orderTypeDics = baseInfo.orderTypeDics;
    this.orderLoadDurationDics = baseInfo.orderLoadDurationDics;
    this.orderVehiclePurposeDics = baseInfo.orderVehiclePurposeDics;
    this.orderIdentifyTypeDics = baseInfo.orderIdentifyTypeDics;
    this.businessTypeOptions = baseInfo.businessTypes;
    var orderReturnReasonTags = baseInfo.orderReturnReasonTags;
    this.failProductReasonDics = baseInfo.failProductReasonDics;
    this.orderReturnReasonTags = orderReturnReasonTags.map((item) => {
      return {
        label: item.split(":")[0],
        radios: item.split(":")[1].split("/"),
      };
    });
    this.retrieveCarOptions();
    this.getOrder();
    this.getSecondDealers();
    this.getProvinces();
    this.retrieveSeriesOptions();
    this.getCompetitionSeriesesOptions();
    // this.getCompetitionSeriesesOptions()
  },
  mounted() { },
  methods: {
    // 返回
    back() {
      if (sessionStorage.getItem("form") === "customerDetail") {
        this.$router.push({
          path: "/customer/detail/" + this.form.customerId,
        });
      } else if (sessionStorage.getItem("form") === "order") {
        this.$router.push({
          path: "/order/zzOrder",
        });
      } else {
        this.$router.go(-1);
      }
    },
    getCompetitionSeriesesOptions() {
      this.$httpAuth
        .post("/v1/dealerRpc/getCompetitionSeriesList", {
          dealerId: this.dealer.dealerId,
          key: "",
        })
        .then(res => {
          this.competitionSeries = res.data.data;
        });
    },
    // 取消
    Cancel() {
      this.disabled = true;
      this.form = JSON.parse(JSON.stringify(this.oldForm));
    },
    Save() {
      if (this.form.customerAddress != "") {
        if (
          (this.form.customerProvince === "" && this.provinces.length > 0) ||
          (this.form.customerCity === "" && this.citys.length > 0) ||
          (this.form.customerCounty === "" && this.countys.length > 1)
        ) {
          this.$message({
            type: "error",
            message: "订车人省/市/区信息不完整，请选择省/市/区",
          });
          return;
        }
      }
      if (this.needCheckOrder) {
        this.SubmitLog = true;
      } else {
        this.saveConfim();
      }
    },
    sendSms() {
      if (this.isSend) {
        this.getCode();
      }
      this.isSend = false;
      this.phoneTimer();
    },
    // 手机倒计时
    phoneTimer() {
      if (this.time > 0) {
        this.time--;
        setTimeout(() => {
          this.phoneTimer();
        }, 1000);
      } else {
        this.isSend = true;
        this.time = 60;
      }
    },
    checkCode() {
      this.$httpAuth
        .post("/v2/appCustomerService/orderCheckSms", {
          dealerId: this.dealer.dealerId,
          orderId: this.orderId,
          code: this.code,
        })
        .then((res) => {
          if (res.data.success) {
            this.saveConfim();
          }
        })
        .catch(() => {
          this.subLoading = false;
        });
    },
    //获取核销码
    getCode() {
      if (this.form.extOrderId === "") {
        return;
      }
      this.$httpAuth
        .post("/v2/appCustomerService/orderSendSms", {
          dealerId: this.dealer.dealerId,
          orderId: this.orderId,
        })
        .then(() => { })
        .catch(() => { });
    },
    async saveConfim() {
      let skuData = await this.$httpAuth
        .post("v2/appVerifyService/getCarModelSku", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carInternalColor: this.form.carInternalColor,
          carWheelBoss: '',
          carWheel: '',
          choosePackage: '',
          ...this.form.carModelOptionals
        })
      if (!skuData) {
        this.confirmLoading = false;
        return
      }
      let params = {
        orderId: this.orderId,
        dealerId: this.dealer.dealerId,
        customerId: Number(this.customerId),
        orderType: this.form.orderType,
        modelId: Number(this.form.modelId[1]),
        modelColor: this.form.modelColor,
        paymentDown: Number(this.form.paymentDown),
        payType: this.form.payType,
        customerPhone: this.form.customerPhone,
        customerProvince: this.form.customerProvince,
        customerCity: this.form.customerCity,
        customerCounty: this.form.customerCounty,
        customerAddress: this.form.customerAddress,
        deliverDate: parseInt(this.form.deliverDate / 1000),
        images1: "",
        images2: "",
        remark: this.form.remark,
        skuCode: skuData.data.skuCode,
        orderReason: this.form.orderReason.join(','),
        competeSeriesId: this.form.competeSeriesId === '' ? 0 : this.form.competeSeriesId,
        businessType: this.form.businessType,
      };
      // let images1 = [];
      // let images2 = [];
      // this.form.images1.forEach((item) => {
      //   images1.push(item.url);
      // });
      // this.form.images2.forEach((item) => {
      //   images2.push(item.url);
      // });
      params.images1 = getUrls(this.form.images1).join(",");
      params.images2 = getUrls(this.form.images2).join(",");
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          var that = this;
          this.$httpAuth
            .post("/v2/appCustomerService/submittedOrderModify", params)
            .then(function (res) {
              if (res.data.code == 202 && res.data.status== -2) {
                that.confirmLoading = false;
                that.blcInfo = {
                  name: that.form.customerName,
                  mobile: that.form.customerPhone,
                  idNo: that.form.identifyType === 1?that.form.identifyNo : that.form.identifyNos,
                  detail: res.data.detail
                }
                that.showBlcTips = true;
                return;
              }
              that.subLoading = false;
              that.SubmitLog = false;
              that.confirmLoading = false;
              if (res.data.orderId) {
                that.disabled = true;
                that.$message({ type: "success", message: "修改成功" });
                that.$router.push({
                  path: "/submitted",
                  query: { id: that.orderId },
                });
              }
            })
            .catch(() => {
              that.subLoading = false;
              that.SubmitLog = false;
              that.confirmLoading = false;
            });
        }
      });
    },
    tagSelect(radio, tagIndex) {
      if (this.backOrderForm.content != radio) {
        this.backOrderForm.content = radio;
        this.backOrderForm.tagIndex = tagIndex;
      } else {
        this.backOrderForm.content = "";
        this.backOrderForm.tagIndex = "";
      }
      this.backOrderForm.competitive = ""
    },
    // 订单退订 已购竞品修改
    competitiveChange() {
      // 情况其他原因
      this.backOrderForm.content = "";
      this.backOrderForm.tagIndex = "";
    },
    tagSelect2(radio, index) {
      if (this.orderCancelForm["content" + (index + 1)] != radio) {
        this.orderCancelForm["content" + (index + 1)] = radio;
      } else {
        this.orderCancelForm["content" + (index + 1)] = "";
      }
    },
    //异常申请确认
    transferConfim() {
      var that = this;
      that.confirmLoading = true;
      let params = {
        dealerId: this.dealer.dealerId,
        orderId: this.orderId,
        image1: this.transferForm.image1,
        image2: this.transferForm.image2,
        image3: this.transferForm.image3,
        image4: this.transferForm.image4,
        reason: "",
      };
      if (this.transferForm.reason === "其他，请描述") {
        if(isEmptyVal(this.transferForm.reason2)) {
          this.$message({
            type: "warning",
            message: "其他原因不能为空，请填写",
          });
          return
        }
        params.reason = this.transferForm.reason2;
      } else {
        params.reason = this.transferForm.reason;
      }
      this.$httpAuth
        .post("/v2/appCustomerService/orderApplyTransferAudit", params)
        .then(function () {
          that.$message({
            type: "success",
            message: "线上订单异常申请提交成功",
          });
          that.transferAudit = false;
          that.confirmLoading = false;
        })
        .catch(() => {
          that.confirmLoading = false;
        });
    },
    //获取异常申请记录
    getTransferAudits() {
      this.$httpAuth
        .post("/v2/appCustomerService/orderTransferAudits", {
          dealerId: this.dealer.dealerId,
          orderId: this.orderId,
        })
        .then((res) => {
          this.transfers = res.data.data;
        })
        .catch(() => { });
    },
    closeViewer() {
      this.showViewer = false;
    },
    uploadBefore() {
      this.uploadData.key = "byd/" + this.$common.uuid();
    },
    // 省改变
    provinceChange(val, isClear = true) {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: val,
          city: "",
        })
        .then((res) => {
          this.citys = res.data.data;
          if(isClear) {
            this.form.customerCity = "";
            this.form.customerCounty = "";
          }
        });
    },
    // 市改变
    cityChange(val, isClear = true) {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: this.form.customerProvince,
          city: val,
        })
        .then((res) => {
          this.countys = res.data.data;
          if(isClear) {
            this.form.customerCounty = "";
          }
        });
    },
    // 获取省
    getProvinces() {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: "",
          city: "",
        })
        .then((res) => {
          this.provinces = res.data.data;
        });
    },
    //合同删除
    // handleRemove1(file) {
    //   if (!this.allowAssignVehicle) {
    //     return;
    //   }
    //   let fileList1 = this.$refs.upload1.uploadFiles;
    //   let index = fileList1.findIndex((fileItem) => {
    //     return fileItem.uid === file.uid;
    //   });
    //   fileList1.splice(index, 1);
    //   setTimeout(() => {
    //     this.hideUpload1 = fileList1.length >= 3;
    //   }, 1000);
    //   this.form.images1.splice(index, 1);
    // },
    // //凭证删除
    // handleRemove2(file) {
    //   if (!this.allowAssignVehicle) {
    //     return;
    //   }
    //   let fileList2 = this.$refs.upload2.uploadFiles;
    //   let index = fileList2.findIndex((fileItem) => {
    //     return fileItem.uid === file.uid;
    //   });
    //   fileList2.splice(index, 1);
    //   setTimeout(() => {
    //     this.hideUpload2 = fileList2.length >= 3;
    //   }, 1000);
    //   this.form.images2.splice(index, 1);
    // },
    // //附件删除
    // handleRemove3(file) {
    //   let fileList3 = this.$refs.upload3.uploadFiles;
    //   let index = fileList3.findIndex((fileItem) => {
    //     return fileItem.uid === file.uid;
    //   });
    //   fileList3.splice(index, 1);
    //   setTimeout(() => {
    //     this.hideUpload3 = fileList3.length >= 3;
    //   }, 1000);
    //   this.transferForm.images.splice(index, 1);
    // },
    retrieveSeriesOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/seriesList", {
          dealerId: this.dealer.dealerId,
          isAll: true,
        })
        .then(function (response) {
          parent.seriesOptions = response.data.records;
        });
    },
    //点击预览
    // handlePictureCardPreview1(file) {
    //   this.fileList = this.form.images1.map((item) => item.url);
    //   const reg = /^https:\/\/.*$/
    //   this.initialIndex = this.form.images1.findIndex(item => {
    //     if(reg.test(file.url)) {
    //       return item.url == file.url
    //     } else {
    //       return item.url == file.response
    //     }
    //   })
    //   this.showViewer = true;
    // },
    // //点击预览
    // handlePictureCardPreview2(file) {
    //   this.fileList = this.form.images2.map((item) => item.url);
    //   const reg = /^https:\/\/.*$/
    //   this.initialIndex = this.form.images2.findIndex(item => {
    //     if(reg.test(file.url)) {
    //       return item.url == file.url
    //     } else {
    //       return item.url == file.response
    //     }
    //   })
    //   this.showViewer = true;
    // },
    //合同改变
    // handleUploadChange1(file, fileList) {
    //   this.hideUpload1 = fileList.length >= 3;
    // },
    // //凭证改变
    // handleUploadChange2(file, fileList) {
    //   this.hideUpload2 = fileList.length >= 3;
    // },
    uploadRequest(option) {
      oss.ossUploadFile(option)
    },
    // //合同上传成功
    // handleUploadSuccess1(res) {
    //   this.form.images1.push({
    //     url: res
    //   });
    // },
    // //交易凭证上传成功
    // handleUploadSuccess2(res) {
    //   this.form.images2.push({
    //     url: res
    //   });
    // },
    //附件上传成功
    handleUploadSuccess3(res) {
      this.transferForm.image1 = res
    },
    handleUploadSuccess4(res) {
      this.transferForm.image2 = res
    },
    handleUploadSuccess5(res) {
      this.transferForm.image3 = res
    },
    handleUploadSuccess6(res) {
      this.transferForm.image4 = res
    },
    parseTime(time, cFormat) {
      if (arguments.length === 0) {
        return null;
      }
      const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
      let date;
      if (typeof time === "object") {
        date = time;
      } else {
        if (("" + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      };
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === "a")
          return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
        if (result.length > 0 && value < 10) {
          value = "0" + value;
        }
        return value || 0;
      });
      return time_str;
    },
    retrieveCarOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/vehicleJsonTree", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.carOptions = response.data.data;
        });
    },
    changeSpecColor(val) {
      this.form.modelColor = "";
      this.form.modelVin = "";
      this.form.carInternalColor = ''
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      this.colors = [];
      this.getVehicleColor(val)
    },
    getVehicleColor(val) {
      const modelId = val[1];
      this.$httpAuth
        .post("/v2/appCustomerService/vehicleColor", {
          modelId: parseInt(modelId),
          dealerId: this.dealer.dealerId,
        })
        .then((response) => {
          this.colors = response.data.data;
        })
        .catch(() => { });
    },
    // 退订
    backOrder() {
      this.backOrderForm = {
        remark: "",
        content: "",
        tagIndex: "",
        competitive: "", // 已购竞品 
      };
      this.backOrderLog = true;
    },
    backOrderConfim() {
      this.$refs["backOrderForm"].validate((valid) => {
        if (valid) {
          var that = this;
          that.confirmLoading = true;
          const { content, tagIndex, competitive, remark } = this.backOrderForm
          let params = {
            dealerId: this.dealer.dealerId,
            orderId: this.orderId,
            remark
          };
          if (content != "") {
            params[`content${tagIndex+1}`] = `${this.orderReturnReasonTags[tagIndex].label}:${content}`;
          } else if (competitive != "") {
            params["content3"] = `${this.orderReturnReasonTags[2].label}:${competitive}`;
            // 只按第一个（或连续多个）空格分割成两部分
            const parts = competitive.split(/\s+/, 1); // 先尝试用 split 取第一个词
            const part1 = parts[0];
            const part2 = competitive.slice(part1.length).trimStart(); // 剩余部分并去掉开头空格
            params.competitionBrand = part1
            params.competitionSeries = part2
          }
          this.$httpAuth
            .post("/v2/appVerifyService/backOrder", params)
            .then(function () {
              that.$message({
                type: "success",
                message: "订单退订成功",
              });
              that.orderCancelLog = false;
              that.confirmLoading = false;
              if (that.type) {
                that.$router.push({
                  path: "/backOrder",
                  query: { id: that.orderId, type: that.type },
                });
              } else {
                that.$router.push({
                  path: "/backOrder",
                  query: { id: that.orderId },
                });
              }
            })
            .catch(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
    modelColorChange() {
      this.form.modelVin = "";
      this.getVins();
      this.form.carInternalColor = '';
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      this.getCarModelDetail();
    },
    carInternalColorChange() {
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      this.getCarModelOptionals()
    },
    getCarModelDetail() {
      this.$httpAuth
        .post("/v2/appVerifyService/getCarModelDetail", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carWheelBoss: '',
          carWheel: '',
          carInternalColor: this.form.carInternalColor,
        }).then(res => {
          this.carInternalColor = res.data.carInternalColor;
          if(this.isEditing && this.carInternalColor && this.carInternalColor[0]) {
            this.form.carInternalColor = this.carInternalColor[0]
            this.getCarModelOptionals()
          }
          const isHasInternalColor = this.carInternalColor.some(Boolean)
          if(!isHasInternalColor) {
            this.getCarModelOptionals()
          }
        })
    },
    getCarModelOptionals() {
      this.$httpAuth
        .post("/v2/appVerifyService/getCarModelOptionals", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carInternalColor: this.form.carInternalColor
        })
        .then((res) => {
          this.carModelOptionalsMaps = res.data;
        });
    },
    // 获取车架号
    getVins() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/vehiclesByOrder", {
          orderId: this.orderId,
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          modelColor: this.form.modelColor,
        })
        .then(function (response) {
          that.vins = response.data.data;
          that.modelDisplay = response.data.modelDisplay;
        })
        .catch(() => { });
    },
    // 获取二级店
    getSecondDealers() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/orderSecondDealers", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (res) {
          that.secondDealers = res.data.data;
        })
        .catch(() => { });
    },
    // 获取订单详情
    getOrder() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/orderDetail", {
          orderId: this.orderId,
          dealerId: this.dealer.dealerId,
        })
        .then(function (res) {
          let data = res.data;
          that.data = res.data;
          that.customerOrder = res.data.order
          that.allowAssignVehicle = that.data.allowAssignVehicle;
          that.allowCancel = that.data.allowCancel;
          that.allowTransferAudit = that.data.allowTransferAudit;
          that.needCheckOrder = that.data.needCheckOrder;
          that.timelines = that.data.timelines;
          let orderReason =  []
          if (that.data.purchaseInfo&&that.data.purchaseInfo.orderReason != '') {
            orderReason = that.data.purchaseInfo.orderReason.split(',')
          }
          const competeSeriesId = that.data.purchaseInfo && that.data.purchaseInfo.competeSeriesId?that.data.purchaseInfo.competeSeriesId:''
          const { carInternalColor = '', carColor, choicePackage1Name, choicePackage2Name,
            choicePackage3Name, choicePackage4Name, choicePackage5Name, choicePackage6Name, choicePackage7Name, 
            choicePackage8Name, choicePackage9Name
           } = data.carInfo || {}
          that.form = {
            referrerName: data.order.referrerName || '无',
            referrerPhone: data.order.referrerPhone || '无',
            otdStatus: that.data.order.otdStatus,
            customerId: that.data.order.customerId,
            extOrderId: that.data.order.extOrderId,
            contractNo: that.data.order.contractNo,
            orderType: that.data.order.orderType || '',
            modelId: [],
            modelColor: carColor || that.data.order.modelColor,
            carInternalColor: carInternalColor,
            carModelOptionals: {
              optional1: choicePackage1Name,
              optional2: choicePackage2Name,
              optional3: choicePackage3Name,
              optional4: choicePackage4Name,
              optional5: choicePackage5Name,
              optional6: choicePackage6Name,
              optional7: choicePackage7Name,
              optional8: choicePackage8Name,
              optional9: choicePackage9Name,
            }, // 车型选装
            modelVin: that.data.order.modelVin,
            isSanbao: that.data.order.isSanbao,
            paymentDown: that.data.order.paymentDown,
            payType: that.data.order.payType,
            paymentDeal: "",
            paymentOther: that.data.order.paymentOther,
            mortgagePayment: that.data.order.mortgagePayment,
            vehiclePurpose: "",
            isReplace: that.data.order.isReplace,
            customerType: that.data.order.customerType,
            customerName:
              that.data.order.customerType === 1
                ? that.data.order.customerName
                : that.data.order.companyName,
            customerPhone: that.data.order.customerPhone,
            identifyType: that.data.order.identifyType,
            identifyNo: that.data.order.identifyNo,
            identifyNos: that.data.order.identifyNo,
            customerAddress: that.data.order.customerAddress,
            deliverDate:
              that.data.order.deliverDate != 0
                ? that.data.order.deliverDate * 1000
                : "",
            // isReport: that.data.order.isReport,
            remark: that.data.order.remark,
            // isOtherDealer: that.data.order.isOtherDealer,
            replacedCarNum: that.data.order.replacedCarNum,
            isSaledBySecond: that.data.order.isSaledBySecond,
            // secondDealerName: that.data.order.secondDealerName,
            nextFollowDate: "",
            customerProvince: that.data.order.customerProvince,
            customerCity: that.data.order.customerCity,
            customerCounty: that.data.order.customerCounty,
            images1: [],
            images2: [],
            replacedBrand: 1,
            replacedSeries: "",
            orderReason,
            competeSeriesId,
            reactivateSource: that.data.reactivateSource || '',
            sourceName: that.data.sourceName || '',
            businessType: that.data.order.businessType || '',
          };
          if (that.data.order.customerProvince != '') {
            that.provinceChange(that.data.order.customerProvince, false);
          }
          if (that.data.order.customerCity) {
            that.cityChange(that.data.order.customerCity, false);
          }
          setTimeout(() => {
            that.form.customerCity = that.data.order.customerCity;
            that.form.customerCounty = that.data.order.customerCounty;
          }, 300);
          // that.fileList1 = [];
          // that.fileList2 = [];
          if (data.order.images1 != "") {
            that.form.images1 = data.order.images1.split(",")
          }
          if (data.order.images2 != "") {
            that.form.images2 = data.order.images2.split(",")
          }
          that.show = true;
          that.getmodelId(that.data.order.modelId);
        })
        .catch((e) => { console.log(e, '============'); });
    },
    formatReferrerName(str = '') {
      return str.replace(/^(.{1})(.*)$/, (match, p1, p2) => p1 + p2.replace(/./g, '*')) || '--'
    },
    formatReferrerPhone(str = '') {
      return str.replace(/^(.{3})(.*)(.{4})$/, (match, p1, p2, p3) => p1 + p2.replace(/./g, '*') + p3) || '--'
    },
    getmodelId(id) {
      var that = this;
      this.$httpAuth
        .post("/v1/baseRpc/getSpec", {
          id: id,
        })
        .then(function (res) {
          that.form.modelId = [
            res.data.spec.seriesId + "",
            res.data.spec.id + "",
          ];
          that.getVehicleColor(that.form.modelId);
          that.form.modelColor = that.data.carInfo ? that.data.carInfo.carColor : that.data.order.modelColor;
          if (that.form.modelColor != "") {
            that.getVins();
          }
          that.getCarModelDetail();
          that.getCarModelOptionals()
          that.form.modelVin = that.data.order.modelVin;
          that.oldForm = JSON.parse(JSON.stringify(that.form));
        })
        .catch(() => { });
    },
    // 驳回确定
    orderCanceConfim() {
      this.$refs["orderCancelForm"].validate((valid) => {
        if (valid) {
          var that = this;
          that.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appVerifyService/rejectOrder", {
              dealerId: this.dealer.dealerId,
              orderId: this.orderId,
              remark: this.orderCancelForm.remark,
              // content1: this.orderBackReasonTags[0].label + ':' + this.orderCancelForm.content1,
              // content2: this.orderBackReasonTags[1].label + ':' + this.orderCancelForm.content2,
              // content3: this.orderBackReasonTags[2].label + ':' + this.orderCancelForm.content3,
              // content4: this.orderBackReasonTags[3].label + ':' + this.orderCancelForm.content4,
              // content5: this.orderBackReasonTags[4].label + ':' + this.orderCancelForm.content5,
            })
            .then(function () {
              that.$message({
                type: "success",
                message: "驳回订单成功",
              });
              that.orderCancelLog = false;
              that.confirmLoading = false;
              that.$router.push({
                path: "/waitingSubmit",
                query: { id: that.orderId },
              });
            })
            .catch(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
    // 去客户详情
    toCustomer() {
      this.$router.push({
        path: "/customer/detail/" + this.form.customerId,
      });
    },
    // 驳回
    reject() {
      this.orderCancelForm = {
        remark: "",
        content1: "",
        content2: "",
        content3: "",
        content4: "",
        content5: "",
      };
      this.orderCancelLog = true;
    },
    // 保存并同步销服
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.customerAddress != "") {
            if (
              (this.form.customerProvince === "" &&
                this.provinces.length > 0) ||
              (this.form.customerCity === "" && this.citys.length > 0) ||
              (this.form.customerCounty === "" && this.countys.length > 1)
            ) {
              this.$message({
                type: "error",
                message: "订车人省/市/区信息不完整，请选择省/市/区",
              });
              return;
            }
          }
          this.orderThroughForm = {
            isSyncSiebel: true,
            remark: "",
          };
          this.orderThroughLog = true;
        }
      });
    },
    // 授权客户经理配车
    inform() {
      this.$confirm("是否授权客户经理配车", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var that = this;
          this.$httpAuth
            .post("/v2/appVerifyService/informOrderVehicle", {
              dealerId: this.dealer.dealerId,
              orderId: this.orderId,
            })
            .then(function (res) {
              if (res.data.success) {
                that.$message({
                  type: "success",
                  message: "授权成功",
                });
                that.toCustomer();
              }
            })
            .catch(() => { });
        })
        .catch(() => { });
    },
    // 确定配车同步销服
    async orderThroughConfim() {
      this.confirmLoading = true;
      let skuData = await this.$httpAuth
        .post("v2/appVerifyService/getCarModelSku", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carInternalColor: this.form.carInternalColor,
          carWheelBoss: '',
          carWheel: '',
          choosePackage: '',
          ...this.form.carModelOptionals
        })
      if (!skuData) {
        this.confirmLoading = false;
        return
      }
      let params = {
        dealerId: this.dealer.dealerId,
        orderId: this.orderId,
        contractNo: this.form.contractNo,
        orderType: this.form.orderType,
        modelId: Number(this.form.modelId[1]),
        modelColor: this.form.modelColor,
        modelVin: this.form.modelVin,
        isSanbao: this.form.isSanbao,
        payType: this.form.payType,
        paymentDown: Number(this.form.paymentDown),
        paymentDeal:
          this.form.paymentDeal === "" ? 0 : Number(this.form.paymentDeal),
        paymentOther:
          this.form.paymentOther === "" ? 0 : Number(this.form.paymentOther),
        vehiclePurpose: this.form.vehiclePurpose,
        isReplace: this.form.isReplace,
        isSaledBySecond: this.form.isSaledBySecond,
        replacedCarNum: this.form.replacedCarNum,
        // secondDealerName: this.form.secondDealerName,
        deliverDate:
          this.form.deliverDate === ""
            ? 0
            : parseInt(this.form.deliverDate / 1000),
        customerType: Number(this.form.customerType),
        customerName:
          Number(this.form.customerType) === 1 ? this.form.customerName : "",
        companyName:
          Number(this.form.customerType) === 2 ? this.form.customerName : "",
        customerPhone: this.form.customerPhone,
        identifyType: this.form.identifyType,
        identifyNo:
          this.form.identifyType === 1
            ? this.form.identifyNo
            : this.form.identifyNos,
        customerProvince: this.form.customerProvince,
        customerCity: this.form.customerCity,
        customerCounty: this.form.customerCounty,
        customerAddress: this.form.customerAddress,
        images1: "",
        images2: "",
        remark: this.form.remark,
        replacedBrand: this.form.replacedBrand,
        replacedSeries: this.form.replacedSeries,
        skuCode: skuData.data.skuCode,
        businessType: this.form.businessType,
      };
      // let images1 = [];
      // let images2 = [];
      // this.form.images1.forEach((item) => {
      //   images1.push(item.url);
      // });
      // this.form.images2.forEach((item) => {
      //   images2.push(item.url);
      // });
      params.images1 = getUrls(this.form.images1).join(",");
      params.images2 = getUrls(this.form.images2).join(",");
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/updateOrderVehicle", params)
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: "success",
              message: "配车成功",
            });
            that.confirmLoading = false;
            that.$router.push({
              path: "/isCar",
              query: { id: that.orderId },
            });
          }
        })
        .catch(() => {
          that.confirmLoading = false;
        });
    },
  },
  watch: {},
  filters: {
    orderStatus(val) {
      for (var i = 0; i < order_vm.orderStatusDics.length; i++) {
        var o = order_vm.orderStatusDics[i];
        if (o.orderStatus == val) {
          return o.name;
        }
      }
      return "";
    },
    auditStatus(val) {
      let map = {
        0: "未处理",
        1: "拒绝",
        2: "通过",
      };
      return map[val];
    },
  },
};
</script>
<style scoped>
.back {
  font-size: 14px;
}

.el-step__title {
  font-size: 14px;
}

.mt2 {
  margin-top: 20px;
}

.mt1 {
  margin-top: 10px;
}

.title {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(10, 18, 32, 0.64);
  letter-spacing: normal;
  margin-bottom: 15px;
  margin-top: 10px;
}

.form_item {
  margin-bottom: 15px !important;
}

.tips {
  width: 100%;
  text-align: center;
  font-weight: 600;
  margin-bottom: 20px;
}

.submit-fo {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.ps {
  width: 100%;
  text-align: center;
  height: 50px;
  font-size: 12px;
  line-height: 40px;
}

.boxLine {
  width: 250px;
  padding: 5px 0 5px 10px;
  border: 1px solid #e8ebed;
  font-size: 12px;
}

.boxLine .title {
  font-weight: 600;
  color: #000;
}

.el-timeline-item__wrapper {
  position: relative;
}

.el-timeline-item__timestamp {
  position: absolute;
  left: -110px;
  top: 0;
}

.toCustomer {
  color: rgb(64, 158, 255);
  cursor: pointer;
  margin-left: 10px;
  font-weight: 400;
}

.hide .el-upload--picture-card {
  display: none;
}

.el-upload-list__item {
  width: 90px !important;
  height: 90px !important;
}

.el-upload {
  width: 90px !important;
  height: 90px !important;
  line-height: 90px !important;
}

.el-image-viewer__btn .el-icon-circle-close {
  color: #fff;
}

.el-radio {
  margin-bottom: 10px;
}

.boxTransfer {
  height: 500px;
  overflow: auto;
  width: 100%;
}

.boxTransfer>div {
  display: flex;
  justify-content: space-between;
  border: 1px solid #c0ccda;
  align-items: center;
  margin-bottom: 7px;
}

.boxTransfer>div>div {
  font-size: 12px;
  line-height: 20px;
  padding-left: 5px;
  box-sizing: border-box;
}

.boxTransfer>div span {
  font-weight: 500;
  margin-right: 20px;
}

.el-tag+.el-tag {
  margin-left: 10px;
}
</style>
